import styled from "styled-components";
import { Wrapper as ClockWrapper } from "./clock/Clock.style";

export const BPMInfo = styled.p`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  color: ${(props) => props.theme.colors.neutrals.primary.graytext};
  &:nth-child(2) {
    margin-top: -0.2rem;
  }
  &:nth-child(3) {
    margin-top: -0.3rem;
  }
`;

export const PlayInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-width: 96px;

  @media ${(props) => props.theme.device.lg} {
    width: 96px;
    margin-right: 3rem;
    padding-top: 0.2rem;
  }
  ${ClockWrapper} {
    margin-top: -0.3rem;
  }
`;

export const Label = styled.span`
  a {
    font-family: ${(props) => props.theme.fonts.aeonik};
    font-style: normal;
    font-weight: 400;
    font-size: 0.8125rem;
    line-height: 1.25rem;
    letter-spacing: 0.005em;
    color: ${(props) => props.theme.colors.neutrals.primary.graytext};
  }
`;

export const Artists = styled.div`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0.005em;
  color: ${(props) => props.theme.colors.neutrals.primary.graytext};
`;

export const MixName = styled.span`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 400;
  font-size: 0.825rem;
  line-height: 1.25rem;
  letter-spacing: 0.005em;
  color: ${(props) => props.theme.colors.neutrals.primary.white};
`;

export const TrackName = styled.span`
  font-family: ${(props) => props.theme.fonts.aeonik};
  font-style: normal;
  font-weight: 500;
  font-size: 0.825rem;
  line-height: 1.25rem;
  letter-spacing: 0.005em;
  color: ${(props) => props.theme.colors.neutrals.primary.white};
`;

export const TrackInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 0.5rem;

  & > *:first-child, & > *:nth-child(2) {
    margin-bottom: -0.6rem;
  }

  @media ${(props) => props.theme.device.md} {    
    max-width: 11rem;       
  }
`;

export const PlayerWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;  
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background: #000;
  padding: 0.5rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
`;
